







































































import {Component, Vue} from "vue-property-decorator";
import RequestW4Modal from "@/components/archive/w4/RequestW4Modal.vue";
import {namespace} from "vuex-class";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import FillableDocumentFilter from "@/dto/archive/FillableDocumentFilter";
import {FillableDocumentType} from "@/dto/archive/FillableDocumentType";
import DocumentService from "@/services/DocumentService";
import FillableDocumentDataDTO from "@/dto/archive/FillableDocumentDataDTO";
import Workspaces from "@/state/Workspaces";
import RouteNames from "@/router/RouteNames";
import {FillableDocumentStatus} from "@/dto/archive/FillableDocumentStatus";
import PaginationComponent from "@/components/util/PaginationComponent.vue";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component<W4List>({
  components: {PaginationComponent},
  computed: {
    FillableDocumentStatus() {
      return FillableDocumentStatus;
    }
  }
})
export default class W4List extends Vue {

  private successful = false;

  private message = "";

  @AppModule.State
  private loading!: boolean;

  @AppModule.Action
  private startLoading!: () => void;

  @AppModule.Action
  private stopLoading!: () => void;

  private forms: Array<FillableDocumentDataDTO> = [];
  private totalPages = 1;
  filter = new FillableDocumentFilter();

  mounted(): void {
    this.loadForms();
  }

  showModal(): void {
    this.$modal.show(
      RequestW4Modal,
      {
          companyId: Workspaces.getCurrent.id,
          onSaved: this.onSaved,
      },
      {width: "50%", height: "auto", scrollable: true}
    );
  }

  loadForms(): Promise<void> {
    this.startLoading();
    this.message = "";
    this.filter.requestingCompanyId = Workspaces.getCurrent.id;
    this.filter.documentType = FillableDocumentType.W_4;
    return DocumentService.getFillableByFilter(this.filter).then(
        success => {
          this.forms = success.data.data;
          this.totalPages = success.data.countOfPages;
        },
        error => this.message = this.$t(ErrorLocalePathUtils.getPathForError(error)) as string)
      .then(() => this.stopLoading());
  }

	onFormClick(form: FillableDocumentDataDTO): void {
    if (form.status === FillableDocumentStatus.NEW || form.status === FillableDocumentStatus.BEING_FILLED_OUT) {
      this.goToForm(form.id);
    }
    if (form.status === FillableDocumentStatus.SIGNED) {
			Vue.prototype.$docUtils.download(form.signedFile!.id);
		}
	}

  private goToForm(id: number) {
    this.$router.push({name: RouteNames.ARCHIVE_W4_INTERNAL, params: { id: `${id}`} });
  }

  onSaved(sublimeFilling: boolean, id: number): void {
    if (sublimeFilling) {
      this.goToForm(id);
    } else {
      this.loadForms();
    }
  }

  private changePage(page: number) {
    this.filter.pageNumber = page;
    this.loadForms();
  }

}
